import { gql } from 'apollo-angular';
import { MutationUpdateMfaPreferenceArgs } from 'gql/graphql';

export const updateMFAPreferenceMutation = gql<
  boolean, MutationUpdateMfaPreferenceArgs
> `
  mutation UpdateMFAPreference(
    $email: String!
    $password: String!
    $preferences: UpdateMFAPreferenceInput!
  ) {
    updateMFAPreference(
      email: $email
      password: $password
      preferences: $preferences
    )
  }
`;
